/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Details_Click_LiveInputs */

const fr_vehicle_details_click_live = /** @type {(inputs: Vehicle_Details_Click_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquer pour voir en direct`)
};

const en_vehicle_details_click_live = /** @type {(inputs: Vehicle_Details_Click_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click to view live`)
};

/**
* | output |
* | --- |
* | "Click to view live" |
*
* @param {Vehicle_Details_Click_LiveInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_details_click_live = /** @type {((inputs?: Vehicle_Details_Click_LiveInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Details_Click_LiveInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_details_click_live(inputs)
	return en_vehicle_details_click_live(inputs)
});